import { render } from "./singlepagefooter.vue?vue&type=template&id=88808472&scoped=true"
const script = {}

import "./singlepagefooter.vue?vue&type=style&index=0&id=88808472&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88808472"]])

export default __exports__